// 正式环境配置
module.exports = {
  urlUser: "http://patent.bt.areaip.cn",
  urlCommon: "",
  baseURL: ""
}
